const DB_NAME = 'nurehab-localdb';
const DB_VERSION = 2;
const STORE_NAME = 'localFiles';

export const openDb = (): Promise<IDBDatabase> => new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    let blocked = false;

    request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
            const store = db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            store.createIndex('id', 'id', { unique: true });
        }
    };
    request.onsuccess = () => {
        const db = request.result;
        db.onversionchange = () => db.close();
        if (blocked) {
            db.close();
            return;
        }
        resolve(db);
    };
    request.onerror = () => reject(request.error);
    request.onblocked = () => {
        blocked = true;
        reject(new Error('Local database upgrade blocked. Close other application tabs and retry.'));
    };
});

// Resolve only after commit; never keep a transaction alive across async ZIP work.
export const withLocalFiles = async <T>(
    mode: IDBTransactionMode,
    action: (store: IDBObjectStore) => IDBRequest<T>
): Promise<T> => {
    const db = await openDb();
    try {
        return await new Promise<T>((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, mode);
            transaction.onabort = () => reject(transaction.error ?? new Error('Local database transaction aborted'));
            try {
                const request = action(transaction.objectStore(STORE_NAME));
                transaction.oncomplete = () => resolve(request.result);
            } catch (error) {
                transaction.abort();
                reject(error);
            }
        });
    } finally {
        db.close();
    }
};
